import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { from } from 'rxjs';
import { Store } from '@ngrx/store';
import { catchError, map } from 'rxjs/operators';
import * as Auth from '../../+state/auth.actions';
import { AuthService } from '../auth/auth.service';

const checkAuthStatus = () => {
  const authService = inject(AuthService);
  const store = inject(Store);
  return authService.checkAndRefreshToken().pipe(
    map((session) => {
      console.log('Auth Guard - Session:', session);
      if (session && session.isValid()) {
        // ✅ Iniciar el timer de refresh si la sesión es válida
        authService.startTokenRefreshTimer();
        return true;
      }
      // Detener el timer si no hay sesión válida
      authService.stopTokenRefreshTimer();
      store.dispatch(Auth.loginRedirect());
      return false;
    }),
    catchError(() => {
      authService.stopTokenRefreshTimer();
      store.dispatch(Auth.loginRedirect());
      return from([false]);
    })
  );
};

export const canActivateFn: CanActivateFn = () => {
  return checkAuthStatus();
};

export const canMatchFn: CanMatchFn = () => {
  return checkAuthStatus();
};
